/**
 * Forecast Detail modal → Block 2 (Latest Plan) row filter.
 *
 * Rules (Feb 2026 — corrected):
 *  - Exclude `DELETED` and `CANCELLED`.
 *  - INCLUDE everything else, including the original plan schedule.
 *
 * Prior behaviour excluded `is_original_plan === true` rows on the
 * theory that Block 1 already showed them (Rahul, Jul 2026). That
 * hid the entire plan history when the original was the only
 * schedule and made Block 2 look empty for forecasts that had never
 * been revised — misleading for operators reading the modal as a
 * single source of truth. The corrected build prompt (Feb 2026)
 * removes only that clause; DELETED/CANCELLED exclusions stay, and
 * the earlier vestigial `status !== "COMPLETED"` exclusion (removed
 * in Jul 2026) remains removed.
 *
 * Not affected by this filter:
 *  - Block 1's row selection (still `is_original_plan === true`).
 *  - Block 2's status badge / coverage math — computed server-side in
 *    `forecast_production_summary.compute_plan_block_statuses`, reads
 *    the raw schedule list, not this filtered array.
 *  - Block 3's "Plan revised N times" (still `=== false`).
 */
export function filterLatestPlanRows(schedules) {
  if (!Array.isArray(schedules)) return [];
  return schedules.filter(s => (
    s.status !== "DELETED" &&
    s.status !== "CANCELLED"
  ));
}
